import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, TrendingUp, ArrowRight } from "lucide-react";

/**
 * Promotional banner inviting B2C / B2B users to boost their listing.
 */
export function BoostPromoBanner({ title, subtitle, ctaLabel, to, testid = "boost-promo-banner" }) {
  return (
    <div
      data-testid={testid}
      className="relative overflow-hidden rounded-2xl findo-gradient text-white p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4"
    >
      <div className="absolute -right-6 -top-8 opacity-20 pointer-events-none">
        <TrendingUp size={140} />
      </div>
      <div className="relative flex-1 min-w-0">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide">
          <Sparkles size={12} /> Boost
        </span>
        <h3 className="mt-2 font-display text-xl sm:text-2xl font-semibold leading-tight">{title}</h3>
        <p className="mt-1 text-sm text-white/85 max-w-xl">{subtitle}</p>
      </div>
      <Link to={to} className="relative shrink-0" data-testid={`${testid}-cta`}>
        <span className="inline-flex items-center gap-2 rounded-full bg-white text-findo-navy px-5 py-3 text-sm font-bold hover:bg-white/90 transition-colors">
          {ctaLabel} <ArrowRight size={16} />
        </span>
      </Link>
    </div>
  );
}
